import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "w-full" }
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "w-0 flex-grow p-2 flex flex-col justify-start items-start" }
const _hoisted_4 = { class: "w-full h-auto flex gap-2 justify-between items-center bg-zewotherm-lightgrey" }
const _hoisted_5 = { class: "text-xs" }
const _hoisted_6 = { class: "w-full flex justify-start items-start" }
const _hoisted_7 = { class: "text-xs w-full h-full" }

import { Comment } from '@/interfaces/comment/Comment'
import User from '@/interfaces/User'
import { useCompany } from '@/store/company'
import { useCurrentUser } from '@/store/currentUser'
import { useUsers } from '@/store/users'
import { alertController } from '@ionic/core'
import { computed } from '@vue/reactivity'
import { ComputedRef } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'CommentDiv',
  props: {
    comment: null
  },
  setup(__props: any) {

const props = __props as {
  comment: Comment
}

const userStore = useUsers()
const companyStore = useCompany()
const currentUserStore = useCurrentUser()



const userOfComment: ComputedRef<User> = computed(() => {
  const user = userStore.users.find((user: User) => {
    return user.id == props.comment.user
  })
  if(user)
    return user
  
  alertController.create({
    message: '',
    buttons: ['Konnte keinen User für das Kommentar' + props.comment._id  + 'finden'] 
  }).then((alert) => {
    alert.present()
  })
  return {} as User
})

const localeDataOfComment = computed(() => {
  const firstFormat = new Date(props.comment.created_at).toLocaleString()
  return firstFormat.slice(0, firstFormat.length-3)
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass([[_unref(userOfComment).id === _unref(currentUserStore).currentUser.user.id ? 'float-right' : 'float-left'], "w-full max-w-4/5 min-h-16 h-auto bg-zewotherm-lightgrey rounded-lg flex items-start justify-start"])
    }, [
      _createElementVNode("img", {
        src: _unref(userOfComment).photo_url,
        class: "h-16 rounded-md mr-2"
      }, null, 8, _hoisted_2),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("p", {
            style: _normalizeStyle([_unref(userOfComment).id === _unref(currentUserStore).currentUser.user.id ? 'color:' + _unref(companyStore).activeCompany.color : '']),
            class: "font-bold"
          }, _toDisplayString(_unref(userOfComment).first_name) + " " + _toDisplayString(_unref(userOfComment).last_name), 5),
          _createElementVNode("p", _hoisted_5, _toDisplayString(_unref(localeDataOfComment)), 1)
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("p", _hoisted_7, _toDisplayString(props.comment.content), 1)
        ])
      ])
    ], 2)
  ]))
}
}

})